import React, { useState, useEffect } from 'react';
import Joyride from 'react-joyride';

const Tour = ({ steps, pageKey }) => {
  const [run, setRun] = useState(false);

  useEffect(() => {
    // Check if the tour is dismissed for this page
    const dismissed = localStorage.getItem(`tour-dismissed-${pageKey}`);
    if (!dismissed) {
      setRun(true);
    }
  }, [pageKey]);

  const handleTourCallback = (data) => {
    const { status } = data;
    if (status === 'finished' || status === 'skipped') {
      // Mark the tour as dismissed for this page
      localStorage.setItem(`tour-dismissed-${pageKey}`, true);
      setRun(false);
    }
  };

  const resetTour = () => {
    // Clear the dismissed state and restart the tour
    localStorage.removeItem(`tour-dismissed-${pageKey}`);
    setRun(true);
  };

  return (
    <>
      <Joyride
        steps={steps}
        run={run}
        callback={handleTourCallback}
        continuous
        showProgress
        showSkipButton
        styles={{
          options: {
            // affects primary elements (incl. primary button background)
            primaryColor: '#0782bb',
            textColor: '#0f172a',
            backgroundColor: '#ffffff',
            zIndex: 10000,
          },
          buttonNext: {
            backgroundColor: '#0782bb',
            color: '#fff',
            borderRadius: 9999,
            padding: '8px 14px',
            fontWeight: 600,
          },
          buttonBack: {
            color: '#0782bb',
            background: 'transparent',
            border: '1px solid #0782bb',
            borderRadius: 9999,
            padding: '6px 12px',
            fontWeight: 600,
          },
          buttonSkip: {
            color: '#64748b',
            background: 'transparent',
          },
          tooltipContainer: {
            // inside tooltip (title + content area)
            textAlign: 'left',
          },
        }}
      />
      {!run && (
        <button className='btn btn-primary btn-xs' onClick={resetTour}>
          <i className='fas fa-eye me-1'></i> View Tour
        </button>
      )}
    </>
  );
};

export default Tour;
